import { createSlice } from '@reduxjs/toolkit'

export const counterSlice = createSlice({
  name: 'data',
  initialState: {
    dataState: {'data': {'fetch': null, 'stream': null},
          'status': {'fetch': false, 'stream': false},
          'date': {'fetch': null, 'stream': null}}
  },
  reducers: {
    dateState: (state, action) => {
      if(action.payload[1] === 1){
        state.dataState.date.fetch = action.payload[0];
      } else {
        state.dataState.date.stream = action.payload[0];
      }
    },
    statusState: (state, action) => {
      if(action.payload === 1){
        state.dataState.status.fetch = true;
      } else {
        state.dataState.status.stream = true;
      }
    },
    dataState: (state, action) => {
      if(action.payload[1] === 1){
        state.dataState.data.fetch = action.payload[0];
      } else {
        state.dataState.data.stream = action.payload[0];
      }
    },
    // streamData_view1: state => {
    //   state.value -= 1
    // },
  }
})

// Action creators are generated for each case reducer function
export const { dateState, statusState, dataState } = counterSlice.actions;

export default counterSlice.reducer;